<template>
  <v-fade-transition mode="out-in">
    <router-view :key="$route.fullPath"> </router-view>
  </v-fade-transition>
</template>

<script>
export default {
  name: "App",

  // created() {
  //   // this.$store.dispatch('setDb', firebase.firestore().collection('items'))

  //   // firebase.firestore().useEmulator("localhost", 5002);

  //   // firebase.functions().useEmulator("localhost", 5001);
  //   firebase.auth().onAuthStateChanged(function(user) {
  //     if (user) {
  //       //  this.$router.push('/home')
  //       // console.log('user from ', user);
  //       const userData = {
  //         id: user.uid,
  //         name: user.displayName,
  //         email: user.email
  //         // registeredItems: [],
  //       };

  //       this.userstate == true;
  //     } else {
  //       // this.$router.push('/register')
  //       this.userstate == false;
  //       console.log("No user is signed in.");
  //     }
  //   });
  //   this.$store.dispatch("loadBookings");
  //   this.$store.dispatch("setUser", userData);
  //   // this.$store.dispatch("fetchUserData");
  //   this.$store.dispatch("loadItems");
  // },

  metaInfo: {
    title: "Strapp",
    titleTemplate: "Strapp",
    content:
      "An online rental marketplace where you can rent out your household items and equipment to others for short term periods.",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      {
        hid: "hid:description",
        name: "description",
        content: "South Africas premier online rental marketplace.",
      },
      { property: "og:site_name", content: "Strapp" },
      { property: "og:type", content: "website" },
      { name: "robots", content: "index,follow" },
      {
        hid: "hid:title",
        property: "og:title",
        content: "Strapp - Transact in your community with confidence",
      },
      { hid: "hid:website", property: "og:type", content: "website" },
      { hid: "hid:image", property: "og:image", content: "/og-image.png" },
      {
        hid: "hid:image-height",
        hid: "hid:image-width",
        property: "og:image:width",
        content: "1280",
      },
      { hid: "hid:image-height", property: "og:image:height", content: "640" },

      { hid: "hid:twitter-card", name: "twitter:card", content: "summary" },
      {
        hid: "hid:twitter-description",
        name: "twitter:description",
        content: "Strapp",
      },
      {
        hid: "hid:twitter-creator",
        name: "twitter:creator",
        content: "@strapprsa",
      },
    ],
  },
};
</script>

<style>
.v-main__wrap {
  background-color: white;
}

html,
body {
  max-width: 100%;
  overflow-x: hidden;
}

.round {
  border-radius: 16px;
}

.grid {
  display: grid;
  place-items: center;
}

.v-btn {
  font-family: "Lexend", sans-serif !important;
  text-transform: unset !important;
  font-display: swap;
}

.button {
  font-family: "Lexend", sans-serif !important;
  font-display: swap;
}

.v-application .display-3 {
  font-family: "Ubuntu", sans-serif !important;
  font-display: swap;
}

.v-application .display-1 {
  font-family: "Ubuntu", sans-serif !important;
  font-display: swap;
}

.v-application .display-2 {
  font-family: "Ubuntu", sans-serif !important;
  font-display: swap;
}

.v-application .title {
  font-family: "Ubuntu", sans-serif !important;
  font-display: swap;
}

.v-application .subtitle-1 {
  font-family: "Ubuntu", sans-serif !important;
  font-display: swap;
  line-height: 1rem !important;
  margin-bottom: 0px !important;
}

.v-application .subtitle-2 {
  font-family: "Ubuntu", sans-serif !important;
  font-display: swap;
}

.v-application .headline {
  font-family: "Ubuntu", sans-serif !important;
  font-weight: 200 !important;
  font-display: swap;
}
</style>
